<template>
    <div>
        <ProductCategorySelectModal
            :selected="selected"
            @change="change"
            @modalClosed="modalClosed"
            :hide-hierarchy-column="hideHierarchyColumn"
            ref="ProductCategorySelectModal"
        />
        <div>
            <slot name="label" :openPopup="openPopup" :buttonLabel="buttonLabel">
                <h5>{{ label }}</h5>
            </slot>

            <slot name="content" :categories="selected" :openPopup="openPopup" :buttonLabel="buttonLabel">
                <slot name="items" :categories="selected">
                    <div class="category-badge-list">
                        <b-badge v-for="category in selected">
                            <slot name="item" :item="category">
                                {{ category[itemLabelProperty] }}
                            </slot>
                        </b-badge>
                    </div>
                </slot>
                <b-button
                    v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                    variant="primary"
                    size="sm"
                    @click="openPopup"
                >
                    {{ buttonLabel }}
                </b-button>
            </slot>
        </div>
    </div>
</template>

<script>
import {BButton, BFormGroup, BCol, BRow, BBadge} from 'bootstrap-vue'
import ProductCategorySelectModal from "@core/components/product/ProductCategorySelectModal";
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'

export default {
    directives: {Ripple},
    components: {
        vSelect, BFormGroup, BButton, BCol, BRow, ProductCategorySelectModal, BBadge
    },
    props: {
        selected: {
            type: Array
        },
        label: {
            type: String,
            default: 'Categories'
        },
        itemLabelProperty: {
            type: String,
            default: 'code'
        },
        buttonLabel: {
            type: String,
            default() {
                return this.$t('Component(Button):manage');
            }
        },
        hideHierarchyColumn: {
            default: false
        }
    },
    methods: {
        openPopup() {
            this.$refs.ProductCategorySelectModal.show();
        },
        change(e) {
            this.$emit('change', e);
        },
        modalClosed() {
            this.$emit('modalClosed');
        }
    },
}
</script>

<style lang="scss">
.category-badge-list {
    display: inline;

    .badge {
        margin-right: 4px;
    }
}
</style>
